import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '@/store/store';  //ver donde se crea el archivo

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674',
};

Vue.use(VueSweetalert2, options);

import JsonViewer from 'vue-json-viewer';
Vue.use(JsonViewer);

import VueBlobJsonCsv from 'vue-blob-json-csv';
Vue.use(VueBlobJsonCsv);

Vue.use(require('vue-moment'));

Vue.use(VueAxios, axios)

Vue.config.productionTip = false

new Vue({
  store,
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
